import React, { ComponentProps } from 'react';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useSettings } from '../hooks/use-settings'

const Img = styled.img`
  display: block;
`
export type ImageProps = {
  src: string
} & ComponentProps<'img'>
export const Image: FunctionComponent<ImageProps> = (props) => {
  return <Img {...props} src={`${props.src.replace(/\.[^.]*$/, '')}.webp`}/>
}
export const AssetImage: FunctionComponent<ImageProps> = (props) => {
  const {themeRootUrl} = useSettings()
  return <Img {...props} src={`${themeRootUrl}/images/${props.src.replace(/\.[^.]*$/, '')}.webp`}/>
}